module.exports = __webpack_public_path__ + "static/media/eyeclose.4d4c3446.svg";